import AboutEvent from "./AboutEvent";
export default AboutEvent;
